import { getUserId } from 'App/services/idpTokenService';
import { SplitTest } from 'Shared/services/opa/api/opaApi';
import { getActiveDecisionVariables, getSplitTestConfigs } from 'Shared/services/opa/app/splitTestService';
import { OPA_FLAG, OPA_VARIABLE } from 'Shared/services/opa/constants';
import { getEnvVar } from 'Shared/utils/envUtils';

export interface YoFiSplitTest extends SplitTest {
  variables: {
    [OPA_VARIABLE.YOFI_ENABLED]: boolean | undefined,
  }
}

/**
 * Calls OPA to get information about the surveys sort split test.
 * @returns The surveys sort split test data.
 */
const getYoFiSplitTest = (): YoFiSplitTest => {
  const decisions = getSplitTestConfigs([OPA_FLAG.YOFI_ANALYTICS]);
  const variables = getActiveDecisionVariables(OPA_FLAG.YOFI_ANALYTICS, decisions);

  return {
    enabled: !!variables,
    variables: {
      [OPA_VARIABLE.YOFI_ENABLED]: variables?.[OPA_VARIABLE.YOFI_ENABLED],
    }
  };
};

let isYoFiEnabled = false;

/**
 * Enable YoFi Tracking
 */
export const initializeYoFiSplitTest = (): void => {
  const yoFiTestEnabled = !!getYoFiSplitTest().variables[OPA_VARIABLE.YOFI_ENABLED];
  const userId          = getUserId(true);
  const publicToken     = getEnvVar('YOFI_TOKEN');

  if (!yoFiTestEnabled || isYoFiEnabled || !userId || !publicToken) {
    return;
  }

  import('@yofi-ai/telemetry-web-sdk').then(({ YofiTelemetry }) => {
    isYoFiEnabled = true;

    YofiTelemetry.initialize({
      publicToken: publicToken,
      journeyIdSalt: window.location.hostname
    });

    YofiTelemetry.startSession({
      duration: 2 * 60 * 60 * 1000, // 2 hours
      labels: {
        'userId': userId
      },
      networkTelemetryConfig: {
        ip: true
      }
    });
  });
};